<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-app id="inspire">
    <v-main class="mainbg">
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12">
              <v-card-text>
                <div class="mb-8 mt-4"><h1>Login</h1></div>
                <v-form>
                  <v-text-field
                    outlined
                    label="Login"
                    name="login"
                    append-icon="mdi-account"
                    v-model="username"
                    type="text"
                    @keyup.enter="login()"
                  ></v-text-field>

                  <v-text-field
                    outlined
                    id="password"
                    label="Password"
                    name="password"
                    append-icon="mdi-lock"
                    type="password"
                    v-model="password"
                    @keyup.enter="login()"
                  ></v-text-field>
                </v-form>
                <div>{{ msg }}</div>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  @click="login()"
                  :loading="loadingbtn"
                  :disabled="disabled"
                  >Login</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { eventBus } from "@/main";
import { __HTTP, FormHeader } from "@/utils/utils";

export default {
  name: "Login",
  props: {
    source: String
  },
  methods: {
    login() {
      this.loadingbtn = true;
      this.disabled = true;
      __HTTP(
        "?do=login",
        JSON.stringify({ username: this.username, password: this.password }),
        FormHeader,
        res => {
          //console.log(res);
          if (res.auth) {
            this.$store.state.loggedUser = {
              id: res.id,
              fullname: res.fullname,
              avatar: res.profilepic,
              jobtitle: res.jobtitle,
              isadmin: res.isadmin,
              showall: res.showall
            };
            eventBus.$emit("login");
          } else {
            this.msg = "Incorrect username and / or password.";
            this.loadingbtn = false;
            this.disabled = false;
          }
        }
      );
    }
  },
  data() {
    return {
      username: "",
      password: "",
      msg: "",
      loadingbtn: false,
      disabled: false
    };
  }
};
</script>

<style>
.mainbg {
  background-image: url("../assets/tajmeeaback.png");
  background-size: cover;
  background-repeat: no-repeat;
}
</style>
